// .../Appointments/RecordTable/TableRow.jsx
import React, { useState } from 'react';
import Classes from './RecordTable.module.css';
import { useNavigate } from 'react-router-dom';
import MoreDropDown from './MoreDropDown';
import DropDown from './StatusDropDown/DropDown';
import UpdateStatusPopup from '../../../../../../../../GlobalComponents/UpdateStatusPopup/UpdateStatusPopup';
import { AnimatePresence } from 'framer-motion';

export default function TableRow({ value, index, onStatusSaved, onCancelled }) {
  const navigateTo = useNavigate();
  const [openUpdateStatusPopup, setOpenUpdateStatusPopup] = useState(false);

  const openPopup = () => setOpenUpdateStatusPopup(true);
  const closePopup = () => setOpenUpdateStatusPopup(false);

  return (
    <>
      <div className={`${Classes.customerRow}`} key={value.bookingId}>
        <div className={`${Classes.rowElem} ${Classes.elem1}`}><h5>{value.serviceType}</h5></div>
        <div className={`${Classes.rowElem} ${Classes.elem2}`}><h5>{value.serviceDate}</h5></div>

        <div className={`${Classes.rowElem} ${Classes.elem3}`}>
          <span onClick={openPopup}>
            <DropDown
              selectedValue={value.status}
              options={["Completed", "Upcoming", "Cancelled", "On the way", "Delayed"]}
              isDropDown={true}
            />
          </span>
        </div>

        <div className={`${Classes.rowElem} ${Classes.elem4}`}><h5>{value.address}</h5></div>

        <div className={`${Classes.rowElem} ${Classes.elem5}`}>
          <MoreDropDown
            bookingId={value.bookingId}
            onCancelled={() => onCancelled?.(value.bookingId)}
            onView={() => navigateTo(`/view-appointment/details/${value.bookingId}`)}
          />
        </div>
      </div>

      {/* Mobile */}
      <div className={Classes.customerRowMobile}>
        <div>
          <div className={Classes.mobElem}><h4>Service Type</h4><h5>{value.serviceType}</h5></div>
          <div className={Classes.mobElem}><h4>Service Date</h4><h5>{value.serviceDate}</h5></div>
        </div>
        <div>
          <div className={Classes.mobElem}>
            <h4>Status</h4>
            <span onClick={openPopup}>
              <DropDown
                selectedValue={value.status}
                options={["Completed", "Upcoming", "Cancelled", "On the way", "Delayed"]}
                isDropDown={true}
              />
            </span>
          </div>
          <div className={Classes.mobElem}><h4>Address</h4><h5>{value.address}</h5></div>
        </div>
        <MoreDropDown
          bookingId={value.bookingId}
          onCancelled={() => onCancelled?.(value.bookingId)}
          onView={() => navigateTo(`/view-appointment/details/${value.bookingId}`)}
        />
      </div>

      <AnimatePresence>
        {openUpdateStatusPopup && (
          <UpdateStatusPopup
            closePopup={closePopup}
            booking={{ _id: value.bookingId }}
            initialStatus={value.status}
            onSaved={(label) => { onStatusSaved?.(value.bookingId, label); closePopup(); }}
          />
        )}
      </AnimatePresence>
    </>
  );
}
